import { render } from "./xtj.vue?vue&type=template&id=597c4144&scoped=true"
import script from "./xtj.vue?vue&type=script&lang=js"
export * from "./xtj.vue?vue&type=script&lang=js"

import "./xtj.vue?vue&type=style&index=0&id=597c4144&lang=less&scoped=true"

import exportComponent from "/Users/a/k618/work/sxdsjtj/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-597c4144"]])

export default __exports__